function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'blau': 'rgb(192, 213, 219)','silber': 'rgb(211, 211, 211)','gold': 'rgb(212, 154, 6)','cream': 'rgb(238, 231, 214)','grau': 'rgb(128, 128, 128)','gelb': 'rgb(255, 229, 0)','lila': 'rgb(165, 77, 207)','rosa': 'rgb(255, 192, 203)','schwarz': 'rgb(0, 0, 0)','grun': 'rgb(5, 170, 61)','marineblau': 'rgb(40, 32, 153)','rot': 'rgb(246, 31, 31)','orange': 'rgb(255, 138, 0)','braun': 'rgb(154, 86, 48)','beige': 'rgb(234, 216, 171)','brau': 'rgb(154, 86, 48)','creme': 'rgb(238, 231, 214)','mint': 'rgb(157, 183, 186)','pfirsich': 'rgb(232, 177, 150)','rose': 'rgb(255, 192, 203)','sand': 'rgb(164, 127, 112)','vanilla': 'rgb(243, 229, 171)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
